<template>
  <div>
    <breadcrumbs :adventure="adventure" :adventureId="adventureId" :chapter="chapter" :chapterId="chapterId" :stageId="stageId" :stage="stage"></breadcrumbs>
    <section id="page-stage-compose" class="mdl-grid adv-content" style="display: block; background-color: white; margin-top:20px;">
      <div class="mdl-cell  mdl-cell--12-col mdl-grid" style="background-color: white; text-align: left;">
        <h5 class="mdl-cell mdl-cell--12-col">Compose Stage</h5>
        <!--<button style="float: right;" @click="clearStage" class="mdl-button mdl-button--colored mdl-button--raised mdl-js-button mdl-js-ripple-effect">Clear Stage</button>-->
        <div id="objectDetails" v-if="selectedInstanceId" class="mdl-cell mdl-cell--12-col mdl-grid" >
          <div class="mdl-cell mdl-cell--6-col">
            <div class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label">
              <select class="mdl-selectfield__select" id="objectType" name="objectType" @change="changeObjectType" >
                <option value="object" :selected="selectedInstance.type==='object'">Stage Object</option>
                <option value="path" :selected="selectedInstance.type==='path'">Path</option>
                <option value="decoration" :selected="selectedInstance.type==='decoration'">Decoration</option>
              </select>
              <label class="mdl-selectfield__label" for="objTypeLbl">Object Type</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
          </div>
          <div v-if="selectedInstance.type==='path'" class="mdl-cell mdl-cell--6-col">
            <div class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label">
              <select :class="{'is-none':selectedInstance.path===''}" class="mdl-selectfield__select" id="stagePath" name="stagePath" @change="changeObjectPath" >
                <option class="is-none" value="" :selected="selectedInstance.path===''">none</option>
                <option v-for="(stage, stageKey) in chapter.stages" :value="stageKey" :selected="selectedInstance.path===stageKey" value="stage">{{stage.name}}</option>
              </select>
              <label class="mdl-selectfield__label" for="objTypeLbl">Path to...</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-cell--12-col" :class="{'is-dirty': selectedInstance.text}" > <!--  -->
              <input class="mdl-textfield__input" type="text" id="sample1" :value="selectedInstance.text" @input="changeInstanceText"> <!--:value="selectedObject.name" @input='updateName' -->
              <label class="mdl-textfield__label" for="sample1">Instance Text...</label>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div class="mdl-selectfield is-dirty mdl-js-selectfield mdl-selectfield--floating-label">
              <select disabled class="mdl-selectfield__select" id="objectType" name="objectType" >
                <option v-for="(object, objectKey) in chapter.objects" :value="objectKey" :selected="selectedInstance.objId===objectKey" value="object">{{object.name}}</option>
              </select>
              <label class="mdl-selectfield__label" for="objTypeLbl">Object Source</label>
              <div class="mdl-selectfield__placeholder"><i class="material-icons" tabindex="-1">arrow_drop_down</i></div>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <button style="margin-top:15px;" @click="maximizeInstance" class="mdl-button mdl-button--colored mdl-button--raised ">
            <i class="material-icons">zoom_out_map</i></button>
            <button style="margin-top:15px;" @click="removeInstance" class="mdl-button mdl-button--raised mdl-js-button mdl-js-ripple-effect">
            <i class="material-icons">delete</i>Remove</button>
          </div>
        </div>
        <div id="objectDetails" v-else class="mdl-cell mdl-cell--12-col mdl-grid" >
          No object selected.
        </div>
        <div class="mdl-cell mdl-cell--12-col">
          <div id="mydropzone" class="dropzone" :style="'position: relative; width: 100%; padding: 28.125% 0 28.125% 0; background-color: #aaa; background-repeat: no-repeat; background-size: contain; background-position: center; background-image: url('+stage.bg+')'">
            <div v-for="(instance, instanceKey) in stage.instances" :name="instanceKey" :class="selectionClass(instanceKey) + ' dropped-element'"
                    :style="'opacity: 0.9; transform: translate('+dimTools.dimFullToView(instance.left,'mydropzone')+'px, '+dimTools.dimFullToView(instance.top,'mydropzone')+'px); height:'+dimTools.dimFullToView(instance.height,'mydropzone')+'px; width:'+dimTools.dimFullToView(instance.width,'mydropzone')+'px; background-image: url('+instance.bg+'); background-color: rgba(1,0,1,0.2); background-repeat: no-repeat; background-size: contain;  background-position: center; position: absolute;'"
                    :data-x="dimTools.dimFullToView(instance.left,'mydropzone')" :data-y="dimTools.dimFullToView(instance.top,'mydropzone')">
            </div>
          </div>
        </div>
        <div class="mdl-cell mdl-cell--12-col" style="margin-top: 0;" >
          <div id="objectCollection" class="mdl-grid">
            <div v-for="(object, objectKey) in chapter.objects" :name="objectKey" :bg="object.bg" class="mdl-cell mdl-cell--6-col draggable drag-element-source"
                    :style="'height:80px; width:100px; background-color: rgba(0,70,200,0.5); background-repeat: no-repeat; background-size: contain;  background-position: center; background-image: url('+object.bg+')'">
                    <div style="pointer-events: none; color:white; text-align: center; text-shadow: 0 0 3px rgba(0,0,0,0.5); overflow:hidden; text-overflow: ellipsis; padding: 5px; ">{{object.name}}</div>
            </div>
            <div class="mdl-cell mdl-cell--12-col" style="text-align: center; font-weight: bold; color: #999;">
              DRAG AND DROP ELEMENTS FROM HERE TO THE STAGE
            </div>
          </div>
        </div>
      </div>  
     </section>
  </div>
</template>

<style>

  .dropped-element.selected{
    outline: solid 3px cyan;
  }

  .mdl-selectfield{
    margin-bottom: 20px;
  }

  .mdl-selectfield__select[disabled]{
    opacity: 0.3;
  }
  
  .mdl-selectfield__placeholder {
    bottom: 0;
    cursor: pointer;
    color: #999;
    left: 0;
    padding: 2px 0;
    position: absolute;
    text-align: right;
    top: 10;
    width: 100%;
    z-index: 1;
  }
  .mdl-selectfield__placeholder > i {
    outline: 0;
  }
  .mdl-selectfield select{
    z-index: 2;
    position: absolute;
    cursor: pointer;
  }
  #objectDetails{
    background-color: rgba(158, 158, 158, 0.15);
    margin-bottom: 0;
    padding: 10px;
    zoom: 0.8;
  }
  #objectCollection{
    background-color: #cccccc;
    margin: 0;
    padding: 0;
  }
  
  .mdl-selectfield select.is-none{
    color: #aaa; 
  }
  .mdl-selectfield select.is-none option{
    color: rgb(44, 62, 80);
  }
  .mdl-selectfield select.is-none option.is-none, .mdl-selectfield option.is-none{
    color: #aaa; 
  }

</style>

<script>
  import Vue from 'vue'
  import Sortable from 'vue-sortable';
  import Breadcrumbs from './Breadcrumbs.vue';
  import DropzoneFirebase from './DropzoneFirebase.vue';
  import DimTools from './DimTools.js';

  Vue.use(Sortable)
  var sectionCompose

  export default{
    components: {
      Breadcrumbs,
      DropzoneFirebase
    },
    data: ()=>({
      adventure: {
        name: "", 
        description: "",
        chapters: {}},
      adventureId: "",
      chapterId: "",
      chapter: {
        name: "", 
        description: ""},
      stage: {bg: ""},
      stageId: "",
      stage: "",
      selectedInstanceId: "",
      selectedInstance: {},
      advRef: {},
      dimTools: {}
    }),
    mounted() {      
     window.startInteract();
     this.refreshInstances();
    },
    created() {
      sectionCompose = this;
      this.dimTools = DimTools;
      window.addEventListener("resize", sectionCompose.refreshInstances, true); 
      this.adventureId = this.$route.params.adventure;
      this.chapterId = this.$route.params.chapter;
      this.stageId = this.$route.params.stage;      
      this.advRef = window.firebase.database().ref('adventures/'+this.adventureId);
      this.advRef.on('value', function(snapshot) {
        sectionCompose.adventure = snapshot.val();
        sectionCompose.chapter = sectionCompose.adventure.chapters[sectionCompose.chapterId];
        sectionCompose.stage = sectionCompose.adventure.chapters[sectionCompose.chapterId].stages[sectionCompose.stageId];
      });
    },
    firebase: {
    },
    methods: {
      refreshInstances(){
        if(this.stage.instances)
        this.stage.instances = Object.assign({},this.stage.instances);
      },
      selectionClass(instanceId){
        return instanceId === this.selectedInstanceId ? "selected" : ""
      },
      selectInstance(instanceId){
        this.selectedInstanceId = instanceId;
        this.selectedInstance = this.stage.instances[this.selectedInstanceId];
      },
      createInstance(left, top, width, height, objId, bg){
        var newInstance = this.advRef.child('chapters').child(this.chapterId).
          child('stages').child(this.stageId).child('instances').push();
          newInstance.set({left: left, top: top, width: width, height: height, objId: objId, bg: bg});
      },
      changeObjectType(event){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.advRef.child('chapters').child(this.chapterId).child('stages').child(this.stageId).
        child('instances').child(this.selectedInstanceId).child('type').set(newValue);
        this.selectedInstance.type=newValue;
      },
      changeObjectPath(event){
        var selectObj = event.target;
        var newValue = selectObj.options[selectObj.selectedIndex].value;
        this.advRef.child('chapters').child(this.chapterId).child('stages').child(this.stageId).
        child('instances').child(this.selectedInstanceId).child('path').set(newValue);
        this.selectedInstance.path=newValue;
      },
      changeInstanceText(event){
        var newValue = event.target.value;
        this.advRef.child('chapters').child(this.chapterId).child('stages').child(this.stageId).
        child('instances').child(this.selectedInstanceId).child('text').set(newValue);
        this.selectedInstance.text=newValue;
      },
      removeInstance(event){
        this.advRef.child('chapters').child(this.chapterId).child('stages').child(this.stageId).
        child('instances').child(this.selectedInstanceId).remove();
        this.selectedInstanceId = "";
        this.selectedInstance = {};
      },
      maximizeInstance(event){
        var path = '/adventures/'+this.adventureId+'/chapters/'+this.chapterId+'/stages/'+this.stageId+'/instances/'+this.selectedInstanceId+'/';
        var updates = {};
        updates[path+'left']= 0;
        updates[path+'top']= -540;
        updates[path+'width']= 1920;
        updates[path+'height']= 1080;
        firebase.database().ref().update(updates);
      },
      clearStage(){
        this.advRef.child('chapters').child(this.chapterId).child('stages').child(this.stageId).
        child('instances').clear();
      }
    }
  }


  function startInteract() {
    
//This will be used for objects to be dropped

    interact('.draggable')
      .draggable({
        manualStart : true,
        onmove(event) {

          var target = event.target;

          var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
          var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
    
          // translate the element
          target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    
          // update the posiion attributes
          target.setAttribute('data-x', x);
          target.setAttribute('data-y', y);
        },
        onend (event) {
          if(event.target){
            var viewportOffset = event.target.getBoundingClientRect();
            var viewportContainerOffset = document.getElementById('mydropzone').getBoundingClientRect();
            // these are relative to the viewport, i.e. the window
            var dims = {};
            dims.left = viewportOffset.left - viewportContainerOffset.left;
            dims.top = viewportOffset.top - viewportContainerOffset.top - (viewportContainerOffset.height/2);          
            dims.width = viewportOffset.width;
            dims.height = viewportOffset.height;
            sectionCompose.dimTools.dimensionsViewToFull(dims, 'mydropzone');

            var instanceId = event.target.getAttribute('name');
            sectionCompose.createInstance(dims.left, dims.top, dims.width, dims.height, instanceId, event.target.getAttribute('bg'));
            event.target.remove();
          }
        },
        restrict: {
          restriction: document.getElementById('mydropzone'),
          elementRect: { left: 0, right: 1, top: 0, bottom: 1 }
        }
      })
      .on('move', function (event) {
          var interaction = event.interaction;

          // if the pointer was moved while being held down
          // and an interaction hasn't started yet
          if (interaction.pointerIsDown && !interaction.interacting() && event.currentTarget.classList.contains('drag-element-source')) {

            var original = event.currentTarget;
            
            // create a clone of the currentTarget element
            var clone = event.currentTarget.cloneNode(true);

            var target = event.target,
            x = (parseFloat(target.getAttribute('data-x')) || 0),
            y = (parseFloat(target.getAttribute('data-y')) || 0);
            
            
            // Remove CSS class using JS only (not jQuery or jQLite) - http://stackoverflow.com/a/2155786/4972844
            clone.className = clone.className.replace(/\bdrag-element-source\b/,'');
              
            // insert the clone to the page
            // TODO: position the clone appropriately
            event.currentTarget.appendChild(clone);

            // start a drag interaction targeting the clone
            interaction.start({ name: 'drag' }, event.interactable, clone);

          } else {

            interaction.start({ name: 'drag' }, event.interactable, event.currentTarget);
          }
      });

//This will be used for dropped objects
    interact('.dropped-element')
      .draggable({
        onend(event){
          var instanceId = event.target.getAttribute('name');
          sectionCompose.selectInstance(instanceId);
          var updates = {};
          var path = '/adventures/'+sectionCompose.adventureId+'/chapters/'+sectionCompose.chapterId+'/stages/'+sectionCompose.stageId+'/instances/'+instanceId+'/';
          updates[path+'left']= event.target.getAttribute('data-x');
          updates[path+'top']= event.target.getAttribute('data-y');
          sectionCompose.dimTools.dimensionsViewToFull(updates, 'mydropzone');
          firebase.database().ref().update(updates);
        },
        onmove(event) {

          var target = event.target;

          var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
          var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
    
          // translate the element
          target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    
          // update the posiion attributes
          target.setAttribute('data-x', x);
          target.setAttribute('data-y', y);
        },
        restrict: {
          restriction: 'parent',
          elementRect: { left: 0, right: 1, top: 0, bottom: 1 }
        }
      })
      .resizable({
        preserveAspectRatio: false,
        edges: { left: true, right: true, bottom: true, top: true },
        restrict: {
          restriction: 'parent',
          elementRect: { left: 1, right: 1, top: 1, bottom: 1 }
        },
        onend(event){
          var updates = {};
          var instanceId = event.target.getAttribute('name');
          sectionCompose.selectInstance(instanceId);
          var path = '/adventures/'+sectionCompose.adventureId+'/chapters/'+sectionCompose.chapterId+'/stages/'+sectionCompose.stageId+'/instances/'+instanceId+'/';

          updates[path+'width']= event.target.clientWidth;
          updates[path+'height']= event.target.clientHeight;
          updates[path+'left']= event.target.getAttribute('data-x');
          updates[path+'top']= event.target.getAttribute('data-y');
          sectionCompose.dimTools.dimensionsViewToFull(updates, 'mydropzone');
          firebase.database().ref().update(updates);
        },
      })
      .on('resizemove', function (event) {
        var target = event.target,
            x = (parseFloat(target.getAttribute('data-x')) || 0),
            y = (parseFloat(target.getAttribute('data-y')) || 0);

        // update the element's style
        target.style.width  = event.rect.width + 'px';
        target.style.height = event.rect.height + 'px';

        // translate when resizing from top or left edges
        x += event.deltaRect.left;
        y += event.deltaRect.top;

        target.style.webkitTransform = target.style.transform =
            'translate(' + x + 'px,' + y + 'px)';

        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
        target.textContent = Math.round(event.rect.width) + '×' + Math.round(event.rect.height);
      }).on('tap', function (event) {
         var instanceId = event.target.getAttribute('name');
          sectionCompose.selectInstance(instanceId);
      });
  }
  window.startInteract = startInteract;
</script>


// WEBPACK FOOTER //
// SectionStageCompose.vue?57bc55c6